export default __webpack_public_path__ + "static/media/1353.105f52e4.png";